
import { defineComponent, ref } from "vue"
import { useStore } from "vuex"

export default defineComponent({
  props: {
    imageSRC: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    slideItem: {
      type: Array || null,
      default: [],
    },
  },
  setup(props) {
    const { commit, dispatch } = useStore()
    const imagePath = ref(props.imageSRC)
    const openSlider = () => {
      commit("useinfo/SET_SLIDE_ITEMS", props.slideItem)
      dispatch("useinfo/openOrCloseSlider")
    }

    imagePath.value = require("@/" + props.imageSRC)

    // 쿼리 셀렉터로 css에 직접 입력되어 마지막에 입력된 이미지 url만 적용됨
    return {
      imagePath,
      openSlider,
    }
  },
})
